import {refundSvg as Icon__small__refundSvg} from '../Icon__small/Icon__small--refund.js'

export var refund = {
  name: 'refund',
  category: 'icon',
  colorable: true,
  svg: Icon__small__refundSvg,
};
